module.exports = __webpack_public_path__ + "img/Icon awesome-share-alt.06384063.svg";